import gql from 'graphql-tag';

export const GET_RESERVE_LIST_BY_DAY = gql`
    query ( $golf_group_code: String!
            $golf_code: String!
            $target_date: String!
            ) {
        getReserveListByDay(golf_group_code: $golf_group_code, golf_code: $golf_code, target_date: $target_date){
            ReserveList{
                play_start
                course_name
                reserve_no
                player_number
                visitor_number
                plan_name
                full_name
                reserve_type
                reserve_type_name
                reserve_situation
                reserve_situation_name
                member_no
            }
        }
    },
`;

export const GET_RESERVE_LIST_BY_CONDITION = gql`
    query ( $golf_group_code: String!,
            $golf_code: String!,
            $reserve_no: String,
            $application_date: String,
            $reserve_situation: Int,
            $member_no: String,
            $family_name: String,
            $given_name: String,
            $play_date: String,
            $begin_row: Int!,
            $cancel_begin_row: Int!,
            $limit_rows: Int!,
            $normal: Boolean
            $share: Boolean
            $message_completed: Boolean
            ) {
        getReserveListByCondition(
                golf_group_code: $golf_group_code,
                golf_code: $golf_code,
                reserve_no: $reserve_no,
                application_date: $application_date,
                reserve_situation: $reserve_situation,
                member_no: $member_no,
                family_name: $family_name,
                given_name: $given_name,
                play_date: $play_date,
                begin_row: $begin_row,
                cancel_begin_row: $cancel_begin_row,
                limit_rows: $limit_rows,
                normal: $normal,
                share: $share,
                message_completed: $message_completed
            ){
            ReserveList{
                play_date
                member_no
                reserve_no
                cell_number
                play_number
                plan_name
                full_name
                reserve_type
                reserve_type_name
                reserve_situation
                reserve_situation_name
                play_start
            },
            count,
            CancelReserveList{
                play_date
                member_no
                reserve_no
                cell_number
                play_number
                plan_name
                full_name
                reserve_type
                reserve_type_name
                reserve_situation
                reserve_situation_name
                play_start
            },
            CancelCount
        }
    },
`;

export const GET_RESERVE_REQUEST_LIST = gql`
    query (
        $golf_group_code: String!
        $golf_code: String!
        $reserve_no: String
        $reserve_type: Int!
        $application_date: String
        $reserve_situation: Int
        $member_no: String
        $family_name: String
        $given_name: String
        $request_date: String
        $message_completed: Boolean
        $begin_row: Int!
        $cancel_begin_row: Int!
        $limit_rows: Int!
    ) {
        getReserveRequestList(
                golf_group_code: $golf_group_code
                golf_code: $golf_code
                reserve_no: $reserve_no
                reserve_type: $reserve_type
                application_date: $application_date
                reserve_situation: $reserve_situation
                member_no: $member_no
                family_name: $family_name
                given_name: $given_name
                request_date: $request_date
                message_completed: $message_completed
                begin_row: $begin_row
                cancel_begin_row: $cancel_begin_row
                limit_rows: $limit_rows
        ){
            ReserveList{
                play_date
                reserve_no
                member_no
                cell_number
                play_number
                plan_name
                full_name
                reserve_type
                reserve_type_name
                reserve_situation
                reserve_situation_name
                reserve_datetime
            }
            count
            CancelReserveList{
                play_date
                reserve_no
                member_no
                cell_number
                play_number
                plan_name
                full_name
                reserve_type
                reserve_type_name
                reserve_situation
                reserve_situation_name
                reserve_datetime
            }
            CancelCount
        }
    }
`;

export const GET_RESERVE_TOTAL_CALC = gql`
    query ( $playDate: String!
            $golfGroupCode: String!
            $golfCode: String!
            ) {
        GetReserveTotalCalc(play_date: $playDate, golf_group_code: $golfGroupCode, golf_code: $golfCode){
            CalcList{
                course_code
                course_name
                total_cell
                total_reserve
                total_player
            }
        }
    },
`;

export const GET_LINK_YEARS = gql`
    query ( $golfGroupCode: String!) {
        GetLinkYears(golf_group_code: $golfGroupCode){
            YearList{
                year
            }
        }
    },
`;

export const GET_RESERVE_TOTAL_LIST_BY_MONTH_INITIALIZE_DATA = gql`
    query {
        GetReserveListByMonthInitializeData {
            GetLoginAdmin{
                user_id
                user_name
                login{
                    golf_group_code
                    golf_code
                    user_div
                    family_name
                    user_id
                }
            }
            OperationAccessList{
                user_div
                vue_id
                vue_name
                element_id
                element_name
                element_control
                display_control
            }
            GetGolfCourseList{
                golf_name
                golf_code
            }
            GolfCode
            YearList{
                year
            }
            TargetYear
            TargetMonth
            TotalList{
                list_no
                list_name
                monthly_total
                day1
                day2
                day3
                day4
                day5
                day6
                day7
                day8
                day9
                day10
                day11
                day12
                day13
                day14
                day15
                day16
                day17
                day18
                day19
                day20
                day21
                day22
                day23
                day24
                day25
                day26
                day27
                day28
                day29
                day30
                day31
            }
            PlanTotalList{
                list_no
                list_name
                plan_id
                plan_name
                fee_id
                total_fee
                monthly_total
                day1
                day2
                day3
                day4
                day5
                day6
                day7
                day8
                day9
                day10
                day11
                day12
                day13
                day14
                day15
                day16
                day17
                day18
                day19
                day20
                day21
                day22
                day23
                day24
                day25
                day26
                day27
                day28
                day29
                day30
                day31
            }
            PlanTotalList{
                list_no
                list_name
                plan_id
                plan_name
                fee_id
                total_fee
                day1
                day2
                day3
                day4
                day5
                day6
                day7
                day8
                day9
                day10
                day11
                day12
                day13
                day14
                day15
                day16
                day17
                day18
                day19
                day20
                day21
                day22
                day23
                day24
                day25
                day26
                day27
                day28
                day29
                day30
                day31
            }
        }
    },
`;

export const GET_RESERVE_TOTAL_LIST_BY_MONTH = gql`
    query ( $targetStart: String!
            $golfCode: String!) {
        GetReserveTotalListByMonth(
            target_start: $targetStart,
            golf_code: $golfCode
        ){
            TotalList{
                list_no
                list_name
                monthly_total
                day1
                day2
                day3
                day4
                day5
                day6
                day7
                day8
                day9
                day10
                day11
                day12
                day13
                day14
                day15
                day16
                day17
                day18
                day19
                day20
                day21
                day22
                day23
                day24
                day25
                day26
                day27
                day28
                day29
                day30
                day31
            }
            PlanTotalList{
                list_no
                list_name
                plan_id
                plan_name
                fee_id
                total_fee
                monthly_total
                day1
                day2
                day3
                day4
                day5
                day6
                day7
                day8
                day9
                day10
                day11
                day12
                day13
                day14
                day15
                day16
                day17
                day18
                day19
                day20
                day21
                day22
                day23
                day24
                day25
                day26
                day27
                day28
                day29
                day30
                day31
            }
        }
    },
`;

export const UPDATE_VISITOR_NUMBER = gql`
    mutation ($reserveNoList: [ReserveNoList]){
        updateVisitorNumber( reserveNoList: $reserveNoList ) {
            result
        }
    }
`;

export const GET_RESERVE = gql`
    query ($reserve_no: String!) {
        GetReserveDetailFromAdmin(
          reserve_no: $reserve_no,
        )
        {
            Reserve {
                golf_code
                golf_name
                address
                telephone
                member_class
                reserve_no
                reserve_type
                reserve_situation
                cell_id
                plan_id
                play_date
                player_left
                player_max
                player_min
                play_number
                cell_number
                plan_name
                total_fee
                detail
                cancel_detail
                course_name
                play_start
                display_course
                add_fee_2b_weekday
                add_fee_2b_weekend
                add_fee_3b_weekday
                add_fee_3b_weekend
                request_first_choice
                request_second_choice
                request_third_choice
                request_contact_info
                groupInfo {
                    add_fee_2b_weekday
                    add_fee_2b_weekend
                    add_fee_3b_weekday
                    add_fee_3b_weekend
                    total_fee
                    play_start
                    cell_id
                    player_number
                    course_name
                    member
                }
                play_together {
                    class_no
                    player_no
                    member_no
                    player_name
                }
                play_style {
                    some_code
                    round_code
                    cart_code
                    caddie_flag
                    meal_flag
                    accommodation_flag
                    competition_flag
                    through_flag
                    lesson_flag
                    reserve_type
                }
            }
        }
    }
`;

export const REGIST_RESERVE = gql`
    mutation(
        $golf_group_code: String
        $member_no: Int
        $golf_code: String
        $plan_id: Int
        $play_date: String
        $cell_number: Int
        $play_number: Int
        $reserve_type: Int
        $cell_id: [Int]
        $cell_player_number: [Int]
        $contact_tel: String
        $request_first_choice: String
        $request_second_choice: String
        $request_third_choice: String
        $request_contact_info: String
        $reserve_no: String
        ){
        RegisterReserveFromAdmin(
            golf_group_code: $golf_group_code
            member_no: $member_no
            golf_code: $golf_code
            plan_id: $plan_id
            play_date: $play_date
            cell_number: $cell_number
            play_number: $play_number
            reserve_type: $reserve_type
            cell_id: $cell_id
            cell_player_number: $cell_player_number
            contact_tel: $contact_tel
            request_first_choice: $request_first_choice
            request_second_choice: $request_second_choice
            request_third_choice: $request_third_choice
            request_contact_info: $request_contact_info
            reserve_no: $reserve_no
        ){
            reserve_no
        }
    }
`;

export const CANCEL_RESERVE = gql`
    mutation($reserve_no: String!){
        cancelReserveFromAdmin(reserve_no: $reserve_no){
            result
        }
    }
`;

export const GET_RESERVE_TYPE = gql`
    query($reserve_no: String!){
        GetReserveTypeFromAdmin(reserve_no: $reserve_no){
            reserveTypeList{
                cell_id
                reserve_type
                member_no
                player_min
            }
        }
    }
`;

export const UPDATE_PLAY_NUMBER = gql`
    mutation(
        $play_number: Int!
        $reserve_no: String
    ){
    updatePlayerNumberFromAdmin(
        play_number: $play_number
        reserve_no: $reserve_no
    ){
        result
    }
}
`;

export const GET_MAX_RESERVE_BRANCH_NO = gql`

    query (
        $reserve_no: String!
    ){
    GetReserveBranchNoFromAdmin(
        reserve_no: $reserve_no,
    ){
        reserve_branch_no
    }
}
`;

export const REGIST_RESERVE_DELETE_CELL = gql`
    mutation(
        $golf_group_code: String
        $member_no: Int
        $golf_code: String
        $plan_id: Int
        $play_date: String
        $cell_number: Int
        $play_number: Int
        $reserve_type: Int
        $cell_id: [Int]
        $cell_player_number: [Int]
        $contact_tel: String
        $request_first_choice: String
        $request_second_choice: String
        $request_third_choice: String
        $request_contact_info: String
        $reserve_no: String
        ){
        RegisterReserveDeleteCellFromAdmin(
            golf_group_code: $golf_group_code
            member_no: $member_no
            golf_code: $golf_code
            plan_id: $plan_id
            play_date: $play_date
            cell_number: $cell_number
            play_number: $play_number
            reserve_type: $reserve_type
            cell_id: $cell_id
            cell_player_number: $cell_player_number
            contact_tel: $contact_tel
            request_first_choice: $request_first_choice
            request_second_choice: $request_second_choice
            request_third_choice: $request_third_choice
            request_contact_info: $request_contact_info
            reserve_no: $reserve_no
        ){
            reserve_no
        }
    }
`;

export const COMPLETE_RESERVE_EMAIL = gql`
    mutation(
        $ReserveEmail: [ReserveEmail]
        ){
        VerifyCompleteReserveEmailFromAdmin(
            ReserveEmailList: $ReserveEmail
            send_admin_emil: false
        ){
            result
        }
    }
`;

export const COMPLETE_RESERVE_CANCEL_EMAIL = gql`
    mutation(
        $reserve_no: String
        ){
        VerifyCompleteReserveCancelEmail(
            reserve_no: $reserve_no
        ){
            result
        }
    }
`;

export const UPDATE_DISPLAY_COURSE = gql`
    mutation(
        $reserve_no: String
        $display_course: Int
        ){
        UpdateDisplayCourse(
            reserve_no: $reserve_no
            display_course: $display_course
        ){
            result
        }
    }
`;

export const GET_RESERVE_ALL_LIST_BY_CONDITION = gql`
    query(
        $golf_group_code: String!
        $reserve_no: String
        $application_date: String
        $reserve_situation: Int
        $member_no: String
        $family_name: String
        $given_name: String
        $play_date: String
        $begin_row: Int!
        $cancel_begin_row: Int!
        $limit_rows: Int!
        $normal: Boolean
        $share: Boolean
        $message_completed: Boolean
        $vue_id: String!
        $element_id: String
    ){
        getReserveAllListByCondition(
            golf_group_code: $golf_group_code
            reserve_no: $reserve_no
            application_date: $application_date
            reserve_situation: $reserve_situation
            member_no: $member_no
            family_name: $family_name
            given_name: $given_name
            play_date: $play_date
            begin_row: $begin_row
            cancel_begin_row: $cancel_begin_row
            limit_rows: $limit_rows
            normal: $normal
            share: $share
            message_completed: $message_completed
            vue_id: $vue_id
            element_id: $element_id
        ) {
            ReserveList{
                play_date
                member_no
                reserve_no
                cell_number
                play_number
                plan_name
                full_name
                reserve_type
                reserve_type_name
                reserve_situation
                reserve_situation_name
                play_start
            }
            count
            CancelReserveList{
                play_date
                member_no
                reserve_no
                cell_number
                play_number
                plan_name
                full_name
                reserve_type
                reserve_type_name
                reserve_situation
                reserve_situation_name
                play_start
            }
            CancelCount
            CodeList{
                code_key
                code
                code_name
                code_key_name
                reserve1
            }
            GetGolfCourseList{
                golf_name
                golf_code
            }
            GetLoginAdmin{
                user_id
                user_name
                login{
                    golf_group_code
                    golf_code
                    user_div
                    family_name
                    user_id
                }
            }
            OperationAccessList{
                user_div
                vue_id
                vue_name
                element_id
                element_name
                element_control
                display_control
            }
        }
    }
`;

export const GET_RESERVE_ALL_LIST_BY_DAY = gql`
    query ( $golf_group_code: String!
            $target_date: String!
            $code_key: String!
            $default_display: String
            $vue_id: String!
            $element_id: String
    ){
        getReserveAllListByDay(
            golf_group_code: $golf_group_code
            target_date: $target_date
            code_key: $code_key
            default_display: $default_display
            vue_id: $vue_id
            element_id: $element_id
        ){
            ReserveList{
                play_start
                course_name
                reserve_no
                player_number
                visitor_number
                plan_name
                full_name
                reserve_type
                reserve_type_name
                reserve_situation
                reserve_situation_name
                member_no
            }
            GetGolfCourseList{
                golf_name
                golf_code
            }
            GetLoginAdmin{
                user_id
                user_name
                login{
                    golf_group_code
                    golf_code
                    user_div
                    family_name
                    user_id
                }
            }
            CodeList{
                code_key
                code
                code_name
                code_key_name
            }
            CalcList{
                course_code
                course_name
                total_cell
                total_reserve
                total_player
            }
            CourseList{
                course_code
                course_name
            }
            OperationAccessList{
                user_div
                vue_id
                vue_name
                element_id
                element_name
                element_control
                display_control
            }
        }
    },
`;
